import React from "react";
import PropTypes from "prop-types";

const DataIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#31237D";

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M10.6916 1.81656C10.2522 1.61616 9.74756 1.61616 9.30822 1.81656L2.16656 5.06656C1.86441 5.19978 1.66943 5.49885 1.66943 5.82906C1.66943 6.15927 1.86441 6.45833 2.16656 6.59156L9.31656 9.84989C9.75589 10.0503 10.2606 10.0503 10.6999 9.84989L17.8499 6.59989C18.152 6.46667 18.347 6.1676 18.347 5.83739C18.347 5.50718 18.152 5.20812 17.8499 5.07489L10.6916 1.81656"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66675 10C1.66595 10.3255 1.85471 10.6216 2.15008 10.7583L9.31675 14.0167C9.75373 14.2145 10.2548 14.2145 10.6918 14.0167L17.8418 10.7667C18.1431 10.6312 18.336 10.3304 18.3334 10"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66675 14.1667C1.66595 14.4922 1.85471 14.7884 2.15008 14.9251L9.31675 18.1834C9.75373 18.3813 10.2548 18.3813 10.6918 18.1834L17.8418 14.9334C18.1431 14.7979 18.336 14.4972 18.3334 14.1667"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DataIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

DataIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default DataIcon;
